<div class="date-picker">
  <ng-container
    *ngIf="availableDates && availableDates.length > 0; else noSlots"
  >
    <h3 class="date-picker__title" [class.hidden]="selectedDate">
      Please choose a day
    </h3>
    <div class="date-picker__list-wrapper">
      <button
        class="date-picker__list__nav"
        (click)="scroll('left')"
        [class.disabled]="!isScrollActive.left"
      >
        <ui-svg-icon
          iconClassName="icon-shared--arrow-left"
          svgId="arrow-right"
        ></ui-svg-icon>
      </button>
      <div class="date-picker__list" #carousel>
        <button
          class="date-picker__list__item"
          (click)="selectDay(dateItem)"
          *ngFor="let dateItem of availableDates; trackBy: trackByDate"
          [ngClass]="{
            selected: dateItem === selectedDate,
            active: dateItem.appointments?.length
          }"
        >
          <div class="date-picker__list__item__day-of-week">
            {{ dateItem.date | date: 'EE' }}
          </div>
          <div class="date-picker__list__item__day-of-month">
            {{ dateItem.date | date: 'dd' }}
          </div>
          <div class="date-picker__list__item__month">
            {{ dateItem.date | date: 'MMM' }}
          </div>
        </button>
      </div>
      <button
        class="date-picker__list__nav"
        (click)="scroll('right')"
        [class.disabled]="!isScrollActive.right"
      >
        <ui-svg-icon
          class="date-picker__list__nav__icon"
          iconClassName="icon-shared--arrow-right"
          svgId="arrow-right"
        ></ui-svg-icon>
      </button>
    </div>
    <ng-container *ngIf="selectedDate">
      <section
        *ngIf="
          selectedDate.appointments && selectedDate.appointments.length;
          else noSlots
        "
        class="time-picker"
      >
        <p class="time-picker__title">Please select a time slot</p>
        <div class="time-picker__list">
          <div
            class="time-picker__list__slot-container"
            *ngFor="let slot of selectedDate.appointments; trackBy: trackById"
          >
            <div
              class="time-picker__list__slot-item"
              (click)="selectTimeSlot(slot)"
              (keydown)="selectTimeSlot(slot)"
              [class.selected]="selectedTimeSlot === slot"
            >
              {{
                selectedTimeSlot === slot
                  ? 'Confirm ' + (slot.startTime | date: 'HH:mm')
                  : (slot.startTime | date: 'HH:mm') +
                    ' - ' +
                    (slot.endTime | date: 'HH:mm')
              }}
            </div>
            <ui-button
              *ngIf="selectedTimeSlot === slot"
              (handleClick)="submitTimeSlot(slot)"
              [isSecondary]="true"
              [gtmTag]="gtmTag"
              buttonClassName="button-full-width"
              buttonId="dates-carousel-timeslot-submit"
              buttonText="Confirm"
            ></ui-button>
          </div>
        </div>
      </section>
    </ng-container>
  </ng-container>
</div>
<ng-template #noSlots>
  <section class="date-picker__no-appointments">
    Unfortunately, there are no available slots at this time but don't panic -
    new slots are added daily. Please check back later.
  </section>
</ng-template>
